<template>
  <div class="add-data">
    <div class="edit-inp">
      <el-form :rules="rules" ref="form" :model="searchForm" label-width="110px">
        <div class="item-box">

          <!-- 更新章节 -->
          {{chapterList}}
          <el-form-item v-for="(item,index) in formList" :key='index' :label="item.label" :prop="item.field">
            <el-input v-if="item.type=='input'" style="width:228px" v-model.trim="searchForm[item.field]"
              :placeholder="item.placeholder">
            </el-input>

            <el-select @change="changeSelect(item.field)" v-if="item.type=='option'"
              v-model.trim="searchForm[item.field]" :placeholder="item.placeholder">
              <el-option :label='"全部"' :value='"全部"'></el-option>
              <el-option v-for="value in item.optionList" :key="value.id" :label="value.label?value.label:value.name"
                :value="value.value?value.value:value.name">
              </el-option>
            </el-select>

            <el-cascader v-if="item.type=='cascader'" v-model.trim="searchForm[item.field]"
              :placeholder="item.placeholder" :props="defaultProps" :options="item.optionList" :show-all-levels="false">
            </el-cascader>

          </el-form-item>
        </div>

        <el-form-item label="是否公开：" prop="openState">
          <el-radio-group v-model.trim="searchForm.openState">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div class="handleBtn">
        <button class="primary" @click.prevent="onSubmit()">确认</button>
        <button class="default" @click="closeBtn">取消</button>
      </div>

    </div>

  </div>
</template>

<script>
import utils from "@/util/index";
import {
  ossUpload,
  getUploadPolicies,
  addResource,
  setResource,
  getChapterTree,
  getLabelSearch,
} from "@/network/resourceRequest/api";
import util from "@/util/index";
export default {
  name: "SearchList",

  props: {
    selectDict: {
      default() {
        return {};
      },
    },

    //是否调用基础级联--------------------------------------------
    isCascade: {
      type: Boolean,
      default() {
        return true;
      },
    },

    searchForm: {
      default() {
        return {};
      },
    },

    //渲染表单列表
    formList: {
      type: Array,
      default() {
        return [
          {
            field: "name",
            type: "input",
            label: "资源名称：",
            placeholder: "填写资源名称",
          },
          {
            field: "phase",
            type: "option",
            label: "学段：",
            placeholder: "选择学段",
            optionList: [],
          },
          {
            field: "course",
            type: "option",
            label: "科目：",
            placeholder: "选择科目",
            optionList: [],
          },
          {
            field: "edition",
            type: "option",
            label: "版本：",
            placeholder: "选择册别",
            optionList: [],
          },
          {
            field: "grade",
            type: "option",
            label: "年级：",
            placeholder: "选择年级",
            optionList: [],
          },

          {
            field: "volume",
            type: "option",
            label: "册别：",
            placeholder: "选择册别",
            optionList: [],
          },

          {
            field: "chapterId",
            type: "cascader",
            label: "章节：",
            placeholder: "选择章节(可不选)",
            optionList: [],
          },
          {
            field: "toll",
            type: "option",
            label: "授权：",
            placeholder: "选择计费方式",
            optionList: [
              {
                value: 1,
                label: "免费",
              },
              {
                value: 2,
                label: "收费",
              },
            ],
          },
        ];
      },
    },

    //级联选择器
    defaultProps: {
      default() {
        return {
          children: "children",
          label: "label",
          value: "id",
          emitPath: false,
        };
      },
    },
  },

  data() {
    return {
      //表单校验规则
      rules: {},
    };
  },

  created() {
    //初始化校验规则
    // this.checkRule();
    this.updataDict();
   
     if (this.isCascade) {
      let typeList = ["course", "edition", "grade", "volume"];
    this.updateRenderObj(typeList);

    }
  },

  methods: {
    //当选项变更时--------------------------------------------
    changeSelect(field) {
      let typeList;
      switch (field) {
        case "phase":
          typeList = ["course", "edition", "grade", "volume"];
          this.updateRenderObj(typeList);
          this.$set(this.searchForm, "course", "");
          this.$set(this.searchForm, "edition", "");
          this.$set(this.searchForm, "grade", "");
          this.$set(this.searchForm, "volume", "");
          break;

        case "course":
          typeList = ["edition", "grade", "volume"];
          this.updateRenderObj(typeList);
          this.$set(this.searchForm, "edition", "");
          this.$set(this.searchForm, "grade", "");
          this.$set(this.searchForm, "volume", "");
          break;

        case "edition":
          typeList = ["grade", "volume"];
          this.updateRenderObj(typeList);
          this.$set(this.searchForm, "grade", "");
          this.$set(this.searchForm, "volume", "");
          break;

        case "grade":
          typeList = ["volume"];
          this.updateRenderObj(typeList);
          this.$set(this.searchForm, "volume", "");
          break;
      }
    },

    //更新列表渲染的对象数据
    updateRenderObj(typeList) {
      //查询数组--------------------------------------------
      let typeArr = [];
      let labelList;
      //封装好查询数组--------------------------------------------
      typeList.forEach((item) => {
        switch (item) {
          //科目--------------------------------------------
          case "course":
            labelList = [];
            if (this.searchForm.phase && this.searchForm.phase != "全部")
              labelList.push(this.searchForm.phase);
            typeArr.push({
              labels: labelList.join(","),
              type: "course",
            });
            break;
          //版本--------------------------------------------
          case "edition":
            labelList = [];
            if (this.searchForm.phase && this.searchForm.phase != "全部")
              labelList.push(this.searchForm.phase);
            if (this.searchForm.course && this.searchForm.course != "全部")
              labelList.push(this.searchForm.course);
            typeArr.push({
              labels: labelList.join(","),
              type: "edition",
            });
            break;
          //年级--------------------------------------------
          case "grade":
            labelList = [];
            if (this.searchForm.phase && this.searchForm.phase != "全部")
              labelList.push(this.searchForm.phase);
            if (this.searchForm.course && this.searchForm.course != "全部")
              labelList.push(this.searchForm.course);
            if (this.searchForm.edition && this.searchForm.edition != "全部")
              labelList.push(this.searchForm.edition);
            typeArr.push({
              labels: labelList.join(","),
              type: "grade",
            });
            break;

          //册别--------------------------------------------
          case "volume":
            labelList = [];
            if (this.searchForm.phase && this.searchForm.phase != "全部")
              labelList.push(this.searchForm.phase);
            if (this.searchForm.course && this.searchForm.course != "全部")
              labelList.push(this.searchForm.course);
            if (this.searchForm.edition && this.searchForm.edition != "全部")
              labelList.push(this.searchForm.edition);
            if (this.searchForm.grade && this.searchForm.grade != "全部")
              labelList.push(this.searchForm.grade);
            typeArr.push({
              labels: labelList.join(","),
              type: "volume",
            });
            break;
        }
      });

      //查询--------------------------------------------
      typeArr.forEach((item) => {
        getLabelSearch(item).then((res) => {
          if (res.data.success) {
            this.formList.forEach((formItem, index) => {
              if (formItem.field == item.type) {
                this.$set(this.formList[index], "optionList", res.data.data);
              }
            });
          } else {
            console.log(res.data.code);
          }
        });
      });
    },

    //初始化校验规则
    checkRule() {
      //校验名称
      let validateName = (rule, value, callback) => {
        if (value === "") {
          switch (rule.field) {
            case "name":
              callback(new Error("输入资源名称"));
              break;
          }
        } else {
          callback();
        }
      };
      //提示规则  //下拉选择框可以默认选择第一个
      this.rules = {
        name: [{ required: true, validator: validateName, trigger: "blur" }],
        course: [{ required: true, message: "请选择科目", trigger: "change" }],
        phase: [{ required: true, message: "请选择学段", trigger: "change" }],
        grade: [{ required: true, message: "请选择年级", trigger: "change" }],
        volume: [{ required: true, message: "请选择册别", trigger: "change" }],
        edition: [{ required: true, message: "请选择版本", trigger: "change" }],
        toll: [
          { required: true, message: "请选择授权方式", trigger: "change" },
        ],
        openState: [
          { required: true, message: "请选择公开状态", trigger: "change" },
        ],
      };
    },

    //表单校验是否通过--------------------------------------------
    formVerification(form) {
      let falg = "";
      this.$refs.form.validate((valid) => {
        if (valid) {
          falg = true;
        } else {
          falg = false;
        }
      });
      return falg;
    },

    //提交按钮--------------------------------------------
    onSubmit() {
      this.$emit("searchFormData", this.searchForm);
      this.$emit("update:searchVisible", false);
    },

    //关闭窗口按钮--------------------------------------------
    closeBtn() {
      this.$emit("update:searchVisible", false);
    },

    //更新dict
    updataDict() {
      for (const key in this.selectDict) {
        if (this.selectDict.hasOwnProperty(key)) {
          this.formList.forEach((item, index) => {
            if (key == "phase" && item.field == "phase") {
              this.$set(
                this.formList[index],
                "optionList",
                this.selectDict[key]
              );
            }
          });
        }
      }
    },
  },

  watch: {
    selectDict() {
      this.updataDict();
    },
  },

  computed: {
    //更新章节
    chapterList() {
      if (
        this.searchForm.course &&
        this.searchForm.edition &&
        this.searchForm.grade &&
        this.searchForm.phase &&
        this.searchForm.volume
      ) {
        let data = {
          course: this.searchForm.course,
          edition: this.searchForm.edition,
          grade: this.searchForm.grade,
          phase: this.searchForm.phase,
          volume: this.searchForm.volume,
        };

        getChapterTree(data).then((res) => {
          if (res.data.success) {
            this.formList.forEach((item, index) => {
              if (item.field == "chapterId") {
                this.$set(this.formList[index], "optionList", res.data.data);
              }
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.add-data {
  user-select: none;
  position: relative;
  width: 100%;
  height: 100%;

  .item-box {
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
      width: 50%;
    }
  }

  //内容

  .handleBtn {
    display: flex;

    align-items: center;
    justify-content: center;

    button {
      margin: 0 100px;
      border: 1px solid #24ba58;
      border-radius: 5px;
      width: 80px;
      height: 40px;

      font-size: 14px;
      line-height: 40px;
      text-align: center;
      letter-spacing: 5px;

      color: #fff;
      background-color: #24ba58;

      outline: none;

      transition: all 0.3s;

      cursor: pointer;

      &:hover {
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);

        transform: translateY(-1px);
      }
    }
  }
}
</style>